import styled from 'styled-components'
import { COLOR } from 'src/service/constant/color'
import main1_bg from 'src/assets/main/main1/main1_bg.png'
import { customMedia } from 'src/styles/common/common'

const Main1SectionWrap = styled.div`
  height: 2145px;
  width: 100%;
  background-color: ${COLOR.gray10};
  margin-top: -25px;

  > img {
    z-index: 995;
    margin: 0 auto 52px auto;
    display: flex;
    position: sticky;
    width: 408.157px;
    top: 360px;
  }
  ${customMedia.lessThan('tablet')`
     height: 1680px;
     >img{
       top: 200px;
       width: 240px;
       margin: 0 auto 140px auto;
  `}
`

const Main1SectionTop = styled.div`
  max-width: 1920px;
  width: 100%;
  margin: -847px auto 0 auto;
  height: 1060px;
  background-color: #d7d7d7;
  background-image: url(${main1_bg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  overflow: hidden;
  ${customMedia.lessThan('tablet')`
      display: block;
      margin: -625px auto 0 auto;
      height: 770px;
   `}
  .lottie {
    position: absolute;
    z-index: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 1428px;
    width: 100%;
    ${customMedia.lessThan('tablet')`
    max-width: 721px;
       top: 20px;
    `}
    ${customMedia.lessThan('tablet_cut_line')`
       position: relative;
       top: -70px;
       width: 600px;
    `}

  }

  > img {
    position: relative;
    z-index: 996;
    top: 23%;
    right: 26%;
    display: flex;
    float: right;
    width: 360px;
    height: 378px;
    ${customMedia.lessThan('main1')`
        right: 25%;
    `}
    ${customMedia.lessThan('main1_2')`
        right: 22%;
    `}
    ${customMedia.lessThan('main1_3')`
        right: 20%;
    `}

  }

  > h3 {
    position: relative;
    font-family: NanumSquareNeoExtraBold, sans-serif;
    padding-top: 132px;
    text-align: center;
    margin: 0 auto;
    font-size: 60px;
    line-height: 80px;
    ${customMedia.lessThan('tablet')`
        padding-top: 27px;
        font-size: 24px;
        line-height: 40px;
    `}
  
  }

  > button {
    position: relative;
    display: flex;
    width: 138px;
    height: 36px;
    margin: 13px auto 0 auto;
    border-radius: 40px;
    background: ${COLOR.white};
    border: 1px solid ${COLOR.point1};
    text-align: center;
    z-index: 800;

    > a {
      display: inline-block;
      width: 100%;
      color: ${COLOR.point1};
      font-size: 14px;
      font-family: NanumSquareNeoHeavy, sans-serif;
      line-height: 36px;
    }

  }

`
const Main1SectionBottom = styled.div`
  height: 964px;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;

  > section {
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    display: block;

    > div {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;

      > p {
        font-family: NanumSquareNeoExtraBold, sans-serif;
        margin: 0;
        font-size: 60px;
        color: ${COLOR.gray30};

      }
    }
  }

  .line1 {
    max-width: 1509px;
    width: 100%;
    height: 66px;
    line-height: 66px;
    margin-top: 167px;
  }

  .line2 {
    max-width: 1609px;
    width: 100%;
    line-height: 80px;
    height: 80px;
    margin-top: 138px;

    &.default {
      opacity: 0;
      visibility: hidden;
      transition: opacity 500ms, visibility 500ms;
    }

    &.active {
      visibility: unset;
      opacity: 1;
      transition: opacity 500ms;
    }

    > p {
      color: ${COLOR.point1};
      font-family: NanumSquareNeoHeavy, sans-serif;
    }
  }

  .line3 {
    max-width: 1635px;
    width: 100%;
    line-height: 66px;
    height: 66px;
    margin-top: 107px;
  }

  .line4 {
    max-width: 1385px;
    width: 100%;
    line-height: 66px;
    height: 66px;
    margin-top: 107px;
  }

  ${customMedia.lessThan('tablet')`
      height: 850px;
      width: 328px;
      >section{
        margin: 37px auto 65px auto;
        text-align: center;
        display: block;
        font-family: NanumSquareNeoExtraBold , san-serif;
        >span{
          display: inline-block;
          width: 255px;
          font-size: 32px;
          line-height: 52px;
          color: ${COLOR.gray40}
        }
        >p{
          display: inline-block;
          width: 100%;
          text-align : center;
          margin: 540px auto 0 auto;
          font-size: 26px;
          line-height: 36px;
          color: ${COLOR.point1};
        }   
      }
   `}
`

export {
  Main1SectionBottom,
  Main1SectionTop,
  Main1SectionWrap

}
